import { Api } from './BaseApi'
import { IStarItem } from '../../types/Star/IStarItem';

export const pinApi = Api.injectEndpoints({
    endpoints: (builder) => ({
        getStars: builder.query<IStarItem[], void>({
            query: () => 'star',
            providesTags: ['Stars'],
        }),
        addStar: builder.mutation<any, IStarItem>({
            query: (newPin) => ({
                url: 'star',
                method: 'POST',
                body: newPin,
            }),
            invalidatesTags: ['Stars'],
        }),
        deleteStar: builder.mutation<any, IStarItem>({
            query: (pin) => ({
                url: `star/${pin.Id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Stars'],
        }),
    }),
});

export default pinApi;